var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 8,
    viewBox: "0 0 32 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.31604C0.723858 3.31604 0.5 3.5399 0.5 3.81604C0.5 4.09218 0.723858 4.31604 1 4.31604L1 3.31604ZM31.3536 4.16959C31.5488 3.97433 31.5488 3.65775 31.3536 3.46248L28.1716 0.280504C27.9763 0.0852416 27.6597 0.0852416 27.4645 0.280504C27.2692 0.475766 27.2692 0.792348 27.4645 0.987611L30.2929 3.81604L27.4645 6.64446C27.2692 6.83973 27.2692 7.15631 27.4645 7.35157C27.6597 7.54683 27.9763 7.54683 28.1716 7.35157L31.3536 4.16959ZM1 4.31604L31 4.31604L31 3.31604L1 3.31604L1 4.31604Z",
    fill: "#131313"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.842aaa3b4c1b9994a4713bbf69baa47d.svg";
export { ForwardRef as ReactComponent };